<template>
    <div id="Equip_info_manage">
      <el-scrollbar :class="isCollapse?'menu_hide rightSide':'rightSide'">
        <el-main>
          <el-breadcrumb separator-class="el-icon-arrow-right" class="mainBread">
            <el-breadcrumb-item :to="{ path: '/' }">{{ $t('HomePage') }}</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/' }">{{ $t('systemConfiguration') }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t('DeviceInformationManagement') }}</el-breadcrumb-item>
          </el-breadcrumb>
          <el-form ref="formselect" :model="formselect" label-width="80px" class="queryform_div">
            <el-form-item :label="$t('DeviceName')">
              <el-input class="queryform"></el-input>
            </el-form-item>
            <el-form-item :label="$t('City')">
              <el-select :placeholder="$t('el.select.placeholder')" @change="getFactoryByCityId(formselect.city)" v-model="formselect.city" class="queryform">
                <el-option v-for="(item,index) in city"
                           :key="'info2-'+index"
                           :label="item.cityName"
                           @click="getFactoryByCityId(item.id)"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('Campus')">
              <el-select :placeholder="$t('el.select.placeholder')" @change="GetBuildingByFactoryId(formselect.pack)" v-model="formselect.pack" class="queryform">
                <el-option v-for="(item,index) in pack"
                           :key="'info2-'+index"
                           :label="item.factoryName"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('Building')">
              <el-select :placeholder="$t('el.select.placeholder')" @change="GetByBuildingId(formselect.building)" v-model="formselect.building" class="queryform">
                <el-option v-for="(item,index) in buiilding"
                           :key="'info2-'+index"
                           :label="item.buildingName"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('Lab')">
              <el-select :placeholder="$t('el.select.placeholder')" v-model="formselect.laboratory" class="queryform">
                <el-option v-for="(item,index) in lab"
                           :key="'info2-'+index"
                           :label="item.labName"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button @click="electricInfo" type="primary">{{ $t('Query') }}</el-button>
              <el-button @click="reset">{{ $t('Reset') }}</el-button>
            </el-form-item>
          </el-form>
          <template>
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addNew" style="margin-bottom:10px;">
              {{ $t('AddNewDevice') }}</el-button>
            <template>
              <el-popconfirm placement="top"
                             :confirmButtonText="$t('Delete')"
                             :cancelButtonText="$t('Cancel')"
                             icon="el-icon-info"
                             iconColor="red"
                             :title="$t('DeleteInformation')">
                <el-button  type="danger" slot="reference" style=" margin-left: 10px;">{{ $t('BatchDelete') }}</el-button>
              </el-popconfirm>
            </template>
            <el-table ref="multipleTable"
                      :data="tableData1"
                      tooltip-effect="dark"
                      @selection-change="handleSelectionChange"
                      border
                      stripe
                      style="width:100%;min-height:200px;">
              <el-table-column fixed="left"
                               type="selection"
                               width="50">
              </el-table-column>
              <el-table-column prop="index"
                               :label="$t('SN')"
                               width="50">
              </el-table-column>
              <el-table-column prop="cityName"
                               :label="$t('City')"
                               width="100">
              </el-table-column>
              <el-table-column prop="factoryName"
                               :label="$t('Campus')"
                               width="100">
              </el-table-column>
              <el-table-column prop="buildingName"
                               :label="$t('Building')"
                               width="100">
              </el-table-column>
              <el-table-column prop="laboratoryName"
                               :label="$t('Lab')"
                               width="100">
              </el-table-column>
              <el-table-column prop="cabinetCode"
                               :label="$t('DeviceName')"
                               width="150">
              </el-table-column>
              <el-table-column prop="type"
                               :label="$t('DesignType')"
                               width="100">
              </el-table-column>
              <el-table-column prop="deviceName"
                               :label="$t('Information')"
                               width="200">
              </el-table-column>
              <el-table-column prop="functionCode"
                               :label="$t('Function')"
                               width="200">
              </el-table-column>
              <el-table-column prop="departmentCode"
                               :label="$t('Department')"
                               width="150">
              </el-table-column>
              <el-table-column prop="levelCode"
                               :label="$t('Grade')"
                               width="100">
              </el-table-column>
              <el-table-column fixed="right"
                               :label="$t('Action')"
                               width="150">
                <template slot-scope="scope">
                  <el-button @click="editInfo(scope.row)" type="primary" size="small">{{ $t('Edit') }}</el-button>
                  <template>
                    <el-popconfirm placement="top"
                                   :confirmButtonText="$t('Delete')"
                                   :cancelButtonText="$t('Cancel')"
                                   icon="el-icon-info"
                                   iconColor="red"
                                   @onConfirm="deleteById(scope.row.id)"
                                   :title="$t('DeleteConfirm')">
                      <el-button size="mini" type="danger" slot="reference" style=" margin-left: 10px;">{{ $t('Delete') }}</el-button>
                    </el-popconfirm>
                  </template>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :total="total">
            </el-pagination>
          </template>

        </el-main>
      </el-scrollbar>

      <el-dialog :title="$t('AddNewDevice')" v-if="dialogAddEquipment" :visible.sync="dialogAddEquipment" width="80%" top="10vh">
        <el-form :inline="true" ref="Eqform" :model="Eqform" label-width="150px">
          <el-form-item :label="$t('Country')">
            <el-select :placeholder="$t('el.select.placeholder')" style="width: 300px;" v-model="Eqform.countryId">
              <el-option v-for="(item,index) in country"
                         :key="index"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('City')">
            <el-select :placeholder="$t('el.select.placeholder')" selected='A' @change="getFactoryByCityId(Eqform.cityId)" style="width: 300px;" v-model="Eqform.cityId">
              <el-option v-for="(item,index) in city"
                         :key="index"
                         :label="item.cityName"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Campus')">
            <el-select :placeholder="$t('el.select.placeholder')" @change="GetBuildingByFactoryId(Eqform.factoryName)" style="width: 300px;" v-model="Eqform.factoryName">
              <el-option v-for="(item,index) in pack"
                         :key="index"
                         :label="item.factoryName"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Building')" prop="buildingId" :rules="[{required:true,message: $t('selectBuilding')}]">
            <el-select :placeholder="$t('el.select.placeholder')" style="width: 300px;" @change="GetByBuildingId(Eqform.buildingId)" v-model="Eqform.buildingId">
              <el-option v-for="(item,index) in buiilding"
                         :key="index"
                         :label="item.buildingName"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Lab')">
            <el-select :placeholder="$t('el.select.placeholder')" multiple  style="width: 300px;" v-model="Eqform.laboratoryIds">
              <el-option v-for="(item,index) in lab"
                         :key="index"
                         :label="item.labName"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('DeviceName')" prop="deviceName" :rules="[{required:true,message: $t('PleaseEnterTheDeviceName')}]">
            <el-input style="width: 300px;" v-model="Eqform.deviceName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Functiontype')" prop="functionCode" :rules="[{required:true,message: $t('PleaseEnterTheFunctionType')}]">
            <el-input style="width: 300px;" v-model="Eqform.functionCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Department')" prop="departmentCode" :rules="[{required:true,message: $t('PleaseEnterDepartment')}]">
            <el-input style="width: 300px;" v-model="Eqform.departmentCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('CabinetNumber')" prop="cabinetCode" :rules="[{required:true,message: $t('PleaseEnterTheCabinetNumber')}]">
            <el-input style="width: 300px;" v-model="Eqform.cabinetCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Brand')" prop="brand" :rules="[{required:true,message: $t('PleaseEnterTheBrand')}]">
            <el-input style="width: 300px;" v-model="Eqform.brand"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Model')" prop="type" :rules="[{required:true,message: $t('PleaseEnterTheModelNumber')}]">
            <el-input style="width: 300px;" v-model="Eqform.type"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Connectedtosystem')" prop="enableInSys" :rules="[{required:true,message: $t('connectToTheSystem')}]">
            <el-select :placeholder="$t('el.select.placeholder')" v-model="Eqform.enableInSys">
              <el-option value="0" :label="$t('yes')">{{ $t('yes') }}</el-option>
              <el-option value="1" :label="$t('No')">{{ $t('No') }}</el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Ratedvoltage')" prop="ratedVoltage" :rules="[{required:true,message: $t('PleaseEnterTheRatedVoltage')}]">
            <el-input style="width: 300px;" v-model="Eqform.ratedVoltage"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Ratedcurrent')" prop="ratedCurrent" :rules="[{required:true,message: $t('PleaseEnterTheRatedCurrent')}]">
            <el-input style="width: 300px;" v-model="Eqform.ratedCurrent"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Accuracy')" prop="accuracy" :rules="[{required:true,message: $t('PleaseEnterAccuracy')}]">
            <el-input style="width: 300px;" v-model="Eqform.accuracy"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Magnification')" prop="magnification" :rules="[{required:true,message: $t('PleaseEnterTheMagnification')}]">
            <el-input style="width: 300px;" v-model="Eqform.magnification"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Position')" prop="location" :rules="[{required:true,message: $t('PleaseEnterTheLocation')}]">
            <el-input style="width: 300px;" v-model="Eqform.location"></el-input>
          </el-form-item>
          <el-form-item :label="$t('SuperiorPowerSupply')" prop="power" :rules="[{required:true,message: $t('superiorPowerSupply')}]">
            <el-input style="width: 300px;" v-model="Eqform.power"></el-input>
          </el-form-item>
          <el-form-item :label="$t('BaudRate')" prop="baudRate" :rules="[{required:true,message: $t('PleaseEnterTheBaudRate')}]">
            <el-input style="width: 300px;" v-model="Eqform.baudRate"></el-input>
          </el-form-item>
          <el-form-item :label="$t('StartingBit')" prop="startBit" :rules="[{required:true,message: $t('PleaseEnterTheStartingPosition')}]">
            <el-input style="width: 300px;" v-model="Eqform.startBit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('TerminationBit')" prop="stopBit" :rules="[{required:true,message: $t('TerminationBit')}]">
            <el-input style="width: 300px;" v-model="Eqform.stopBit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('CheckDigit')" prop="verifyBit" :rules="[{required:true,message: $t('PleaseEnterTheCheckDigit')}]">
            <el-input style="width: 300px;" v-model="Eqform.verifyBit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Remarks')" prop="remark" :rules="[{required:true,message: $t('PleaseEnterNote')}]">
            <el-input style="width: 300px;" v-model="Eqform.remark"></el-input>
          </el-form-item>
          <el-form-item style="text-align: center;width: 100%;">
            <el-button type="success" @click="onSubmit('Eqform')">{{ $t('Confirm') }}</el-button>
            <el-button @click="dialogAddEquipment = false">{{ $t('Cancel') }}</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
</template>

<script>
  import {mapState} from 'vuex';
  import {GetAllElectricInfo,updateElectric,getCityAll,DeleteElectric,createElectric,GetLabByBuildingId,getFactoryAll,GetAllBuilding,getLabAll,GetByCityId,GetByFactoryId} from '../../api/api';
    export default {
        name: "Equipment_information_management",
      data() {
        return{
          dialogAddEquipment: false,
          dialogEditEquipment: false,
          currentPage:0,
          total:0,
          tableData1: [],
          multipleSelection: [],
          formselect: {
            city:"",
            pack:'',
            building:"",
            laboratory:"",
          },
          userform: {
                  id: '',
                  name: '',
                  paw: '',
                  dept: '',
                  email: '',
                  tel: '',
              },
          Eqform: {
                  countryId:'',
                  cityId:'',
                  factoryName:'',
                  buildingId:'',
                  laboratoryIds:[],
                  lab:'',
                  deviceName:'',
                  functionCode:'',
                  departmentCode:'',
                  cabinetCode:'',
                  brand:'',
                  type:'',
                  enableInSys:'',
                  ratedVoltage:'',
                  ratedCurrent:'',
                  accuracy:'',
                  magnification:'',
                  location:'',
                  power:'',
                  baudRate:'',
                  startBit:'',
                  stopBit:'',
                  verifyBit:'',
                  remark:'',
              },
          country: [{
            value: '00000000-0000-0000-0000-000000000000',
            label: '中国'
          }],
          city: [],
          pack: [],
          buiilding: [],
          lab: [],
          devicetype: [
                  {
                      value: '1',
                      label: this.$t('collector')
                  }, {
                      value: '2',
                      label: this.$t('LORAGateway')
                  }, {
                      value: '3',
                      label: this.$t('TH-CALC'),
                  }],
          devicedept: [
                  {
                      value: '1',
                      label: this.$t('TestDepartment') + '1'
                  }, {
                      value: '2',
                      label: this.$t('TestDepartment') + '2'
                  }, {
                      value: '3',
                      label: this.$t('TestDepartment') + '3',
                  }],
          devicelevel: [
                  {
                      value: '1',
                      label: '1'
                  }, {
                      value: '2',
                      label: '2'
                  }, {
                      value: '3',
                      label: '3',
                  }],
          clickBtn:"",
          }
      },
      mounted(){
        this.electricInfo()
        this.getAllCity('')       //获取城市
        // this.getAllFactory()    //获取园区
        // this.GetBuildingAll()   //获取楼宇
        // this.getAllLab()        //获取实验室
      },
      methods: {
        addNew(){
          this.dialogAddEquipment = true
          this.clickBtn=''
        },
        handleCurrentChange(val){
          this.currentPage = JSON.parse(val) *10;
        },
        editInfo(e){
          this.dialogAddEquipment=true
          e.enableInSys = e.enableInSys?"0":"1"
          this.Eqform = e
          this.clickBtn = 'edit'
          this.getAllCity('')
        },
        getFactoryByCityId(FilterText){
          var that = this
          GetByCityId(FilterText).then(res=>{
            if(res.success){
              that.pack = res.result
              that.Eqform.pack=''
              that.Eqform.buiilding=''
              that.Eqform.lab=''
              that.formselect.pack = ''
              that.formselect.building = ''
              that.formselect.laboratory = ''
            }
          })
        },
        GetBuildingByFactoryId(FilterText){
          var that = this
          GetByFactoryId(FilterText).then(res=>{
            if(res.success){
              that.buiilding = res.result
              that.Eqform.buiilding=''
              that.Eqform.lab=''
              that.formselect.building = ''
              that.formselect.laboratory = ''
            }
          })
        },
        GetByBuildingId(FilterText){
          var that = this
          GetLabByBuildingId(FilterText).then(res=>{

            if(res.success){
              that.lab = res.result
              that.Eqform.lab=''
              that.formselect.laboratory = ''
            }
          })
        },
        getAllCity(FilterText){
          var that = this
          getCityAll(FilterText).then(res=>{

            if(res.success){
              that.$nextTick(function () {
                that.city = res.result.items
                if(this.clickBtn == 'edit'){
                  that.getAllFactory(FilterText)    //获取园区
                }
              })
            }
          })
        },
        getAllFactory(FilterText){
          var that = this
          getFactoryAll(FilterText).then(res=>{
  
            if(res.success){
              that.pack = res.result.items
              that.GetBuildingAll(FilterText)   //获取楼宇
            }
          })
        },
        GetBuildingAll(FilterText){
          var that = this
          GetAllBuilding(FilterText).then(res=>{
  
            if(res.success){
              that.buiilding = res.result.items
              that.formselect.building = res.result.items
              that.getAllLab(FilterText)        //获取实验室
            }
          })
        },
        getAllLab(FilterText){
          var that = this
          getLabAll(FilterText).then(res=>{
            if(res.success){
              that.lab = res.result.items
              that.formselect.laboratory = res.result.items
            }
          })
        },
        reset(){
          this.formselect = {
            building:'',
            city:'',
            laboratory:'',
            pack:'',
          }
          this.electricInfo()
         },
        electricInfo(){
          var that = this,data = {
            currentPage:this.currentPage,
            CityCode:this.formselect.city,
            FactoryCode:this.formselect.pack,
            BuildCode:this.formselect.building,
            LabCode:this.formselect.laboratory,
          }

          if(this.formselect.city){
            this.city.map(item=>{
              if(item.id==this.formselect.city){
                data.CityCode = item.cityCode
              }
            })
          }
          if(this.formselect.pack){
            this.pack.map(item=>{
              if(item.id==this.formselect.pack){
                data.FactoryCode = item.factoryCode
              }
            })
          }
          if(this.formselect.building){
            this.buiilding.map(item=>{
              if(item.id==this.formselect.building){
                data.BuildCode = item.buildCode
              }
            })
          }
          if(this.formselect.laboratory){
            this.lab.map(item=>{
              if(item.id==this.formselect.laboratory){
                data.LabCode = item.labCode
              }
            })
          }
          GetAllElectricInfo(data).then(res=>{

            if(res.success){
              that.total = res.result.totalCount
              that.tableData1 = res.result.items
              that.tableData1.forEach((item,index)=>{
                item.index = index+1
              })
            }
          })
        },
        deleteById(id){

          var data = {id},that = this
          DeleteElectric(data).then(res=>{

            if(res.success){
              that.$message.success(this.$t('deleteSuccessful'))
              that.electricInfo()
            }
          })
        },
        onSubmit(Eqform) {
          var that = this
          this.$refs[Eqform].validate((valid) => {
            if (valid) {
              var data = this.Eqform
              data.enableInSys = data.enableInSys=="0"?true:false

              delete data.buiilding
              delete data.lab
              delete data.pack
              delete data.countryId
              delete data.cityId
                if(this.clickBtn=='edit'){
                  updateElectric(data).then(res=>{
                    that.$message.success(this.$t('Update'))
                  })
                }else{
                  createElectric(data).then(res=>{

                    if(res.success){
                      that.$message.success(this.$t('NewSuccessfullyCreated'))
                    }else{
                      that.$message.error(res.error.message)
                    }
                  })
                }
                that.electricInfo()
                that.Eqform = {
                  country:'',
                  city:'',
                  pack:'',
                  BuildingId:'',
                  LaboratoryIds:[],
                  lab:'',
                  deviceName:'0',
                  functionCode:'',
                  departmentCode:'',
                  cabinetCode:'',
                  brand:'',
                  type:'',
                  enableInSys:'0',
                  ratedVoltage:'',
                  ratedCurrent:'',
                  accuracy:'',
                  magnification:'',
                  location:'',
                  power:'',
                  baudRate:'',
                  startBit:'',
                  stopBit:'',
                  verifyBit:'',
                  remark:'',
                }
                that.dialogAddEquipment = false
            }else{
              return false;
            }
          })
        },
        handleSelectionChange(val) {
          this.multipleSelection = val;
        }
      },
      computed:mapState({
        isCollapse:state=>state.isCollapse
      }),
    }
</script>

<style scoped>
  #formPer .el-form-item__content {
    line-height: 35px;
    border-left: 1px solid #EBEEF5;
    padding-left: 10px;
  }

  #formPer > .el-form-item {
    margin-bottom: 0px;
    border-bottom: 1px solid #EBEEF5;
  }

  #formPer .noborder .el-form-item__content {
    border: 0;
  }

  #formPer .noborder {
    border: 0;
    margin-top: 20px;
  }
</style>
